import { httpClient } from "./httpClient";

const baseEntregas = "/api/entregas";

export const listarEntregasPorEstudiante = (estudianteId) =>
  httpClient.get(`${baseEntregas}/estudiante/${estudianteId}`);

export const upsertEntregablesMatricula = (matriculaId, entregables = [], { fecha_entrega_override } = {}) =>
  httpClient.post(`/api/matriculas/${matriculaId}/entregables`, {
    entregables,
    ...(fecha_entrega_override ? { fecha_entrega_override } : {}),
  });

const entregasService = {
  listarEntregasPorEstudiante,
  upsertEntregablesMatricula,
};

export default entregasService;
